(() => {
  const popup = document.getElementById('popup-residential-country');

  if (!popup) {
    return;
  }

  const submit = popup.querySelector('.popup-residential-country-footer-submit');
  const isFormCorrect = () => !!popup.querySelector('#pdp-customer-residential-country').value;
  const verifyForm = () => {
    if (!isFormCorrect()) {
      submit.disabled = true;
      submit.classList.add('disabled');
    } else {
      submit.disabled = true;
      submit.classList.remove('disabled');
    }
  };

  popup.querySelector('#pdp-customer-residential-country').addEventListener('change', e => {
    verifyForm();
  });

  submit.addEventListener('click', e => {
    e.preventDefault();

    if (submit.classList.contains('disabled')) {
      return;
    }

    submit.classList.add('disabled');

    window.app.customer.updateResidentialCountry(popup.querySelector('#pdp-customer-residential-country').value)
      .then(res => {
        document.querySelectorAll('.static-select-value[data-residential-country]').forEach((staticSelect) => staticSelect.innerText
          = app.getCountryNameByIsoCode(app.customer.residentialCountry)
        );

        if (window.location.pathname === '/cart') {
          popup.close();

          return;
        }

        window.location.reload();
      })
      .catch(err => {
        console.log(err);
      });

    //popup.close();
  });

  verifyForm();
})();